

import React, {Component} from 'react';
import jMoment from 'moment-jalaali';
import { withTranslation } from 'react-i18next';
import {compose} from 'redux';
class ProcessInfo extends Component {
	render() {
		return (
			<div>
				<table className="table table-bordered">
					<tbody>
						<tr>
							<td> {this.props.t('Title')}</td>
							<td> {this.props.processInfo.PRO_TITLE ? this.props.processInfo.PRO_TITLE : this.props.t('Not Value')} </td>
						</tr>
						<tr>
							<td> {this.props.t('Description')}</td>
							<td>{this.props.processInfo.PRO_DESCRIPTION ? this.props.processInfo.PRO_DESCRIPTION : this.props.t('Not Value')}</td>
						</tr>
						<tr>
							<td> {this.props.t('Category')}</td>
							<td>{this.props.processInfo.PRO_CATEGORY_LABEL}</td>
						</tr>
						<tr>
							<td> {this.props.t('Author')}</td>
							<td>{this.props.processInfo.PRO_AUTHOR}</td>
						</tr>
						<tr>
							<td>{ this.props.t('Create Date') }</td>
							<td>{jMoment(this.props.processInfo.PRO_CREATE_DATE).format('HH:mm:ss jYYYY/jMM/jDD')}</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}

export default withTranslation()(ProcessInfo);